import React from "react";
import styled from "styled-components";
import AddonSvg from "../../../images/svg/addon-orange.svg";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 12px;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const Icon = styled(AddonSvg)`
  width: 22px;
  height: 22px;
  margin-top: 2px;

  @media (max-width: 992px) {
    display: none;
  }
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
`;

const PriceLineOne = styled.div`
  font-weight: 700;
  font-size: 18px;
  margin-top: 10px;
  line-height: 1.1;
`;

const PriceLineTwo = styled.div`
  font-size: 13px;
  opacity: 0.85;
  margin-top: 8px;
`;

const Description = styled.div`
  font-size: 14px;
  opacity: 0.9;
  margin-top: 10px;
  line-height: 1.35;
  max-width: 300px;
`;

const AddonCard = ({ addon }) => {
  if (!addon) return null;

  const { title, price_line_one, price_line_two, description } = addon;

  return (
    <Wrapper>
      <Icon />
      <div>
        {title && <Title>{title}</Title>}
        {price_line_one && <PriceLineOne>{price_line_one}</PriceLineOne>}
        {price_line_two && <PriceLineTwo>{price_line_two}</PriceLineTwo>}
        {description && <Description>{description}</Description>}
      </div>
    </Wrapper>
  );
};

export default AddonCard;
